import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * Device fingerprint for audit; {@link employeeId} from parent INIT is the business unique key.
 */
class FingerprintService {
  private visitorId: string | null = null;
  private employeeId = 'guest';
  private initPromise: Promise<void> | null = null;

  setEmployeeId(employeeId: string): void {
    this.employeeId = employeeId;
  }

  getEmployeeId(): string {
    return this.employeeId;
  }

  async init(): Promise<void> {
    if (!this.initPromise) {
      this.initPromise = this.load();
    }
    await this.initPromise;
  }

  async getVisitorId(): Promise<string> {
    await this.init();
    return this.visitorId ?? 'unknown';
  }

  private async load(): Promise<void> {
    const agent = await FingerprintJS.load();
    const { visitorId } = await agent.get();
    this.visitorId = visitorId;
  }
}

export const fingerprintService = new FingerprintService();
